import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $data.showPicker,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.showPicker = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      "show-toolbar": "",
      loading: $data.isLoading,
      columns: $data.columns,
      "columns-field-names": $props.columnsFieldNames,
      onConfirm: $options.onConfirmClick,
      onCancel: $options.onCancelClick
    }, null, 8, ["loading", "columns", "columns-field-names", "onConfirm", "onCancel"])]),
    _: 1
  }, 8, ["show"]);
}